import { useUser } from "../functional-components/UserContext";
import { cockpitEditUrl } from "../utils/CmsUtils";
import Icon from "./Icon";
import { useBjelinTranslations } from "../hooks/TranslationHooks";
import { useLang } from "../hooks/LangHooks";

const CockpitEditLink = ({
  collection,
  labelKey = "",
  _id = "",
  wrapper = children => <div className={"text-center"}>{children}</div>,
  ...props
}) => {
  const t = useBjelinTranslations();
  const lang = useLang();
  const { admin } = useUser();
  return admin
    ? wrapper(
        <a
          href={cockpitEditUrl(collection, _id, lang)}
          target="_blank"
          rel="noopener noreferrer"
          {...props}
        >
          {t(labelKey)} <Icon name="pen-to-square" />
        </a>
      )
    : null;
};

export default CockpitEditLink;
